import React from 'react';
import QuickFormPageContent from './QuickFormPageContent';
import withQuickForm from '../withQuickForm';
import { DOCUMENT_EXTERNAL_EVENTS } from '../../helpers/utils';
import PropTypes from 'prop-types';
import withQuickFormDocument from '../withQuickFormDocument';
import { DocumentRejectedMessage } from '../../common/DocumentRejectedMessage';

class InPageQuickForm extends React.Component {
  componentDidUpdate(prevProps, prevState, snapshot) {
    this.props.checkSignal(DOCUMENT_EXTERNAL_EVENTS.NEXT_STEP, () =>
      this.props.goNextStep()
    );
    this.props.checkSignal(DOCUMENT_EXTERNAL_EVENTS.PREV_STEP, () =>
      this.props.goPrevStep()
    );
  }

  render() {
    return (
      <div className={'document-page-container'}>
        {this.props.showTitleAndInfo}
        <div className={'common-page-content'}>
          {this.props.document?.rejected && <DocumentRejectedMessage />}
          <div
            className={'document-page-body'}
            style={{
              background: '#fff',
              padding: 20,
              marginTop: 10,
              marginBottom: 80,
              overflow: 'visible'
            }}
          >
            <QuickFormPageContent {...this.props} />
          </div>
        </div>
      </div>
    );
  }
}

InPageQuickForm.propTypes = {
  showTitleAndInfo: PropTypes.any,
  goPrevStep: PropTypes.func,
  goNextStep: PropTypes.func,
  checkSignal: PropTypes.func,
  document: PropTypes.object
};
export default withQuickFormDocument(withQuickForm(InPageQuickForm));
